import React from "react";
import { motion } from "framer-motion";
import { Users, Database, Upload, TrendingUp } from "lucide-react";

const ContactStatsCards = ({ stats }) => {
  const statsData = [
    {
      title: "Total Contacts",
      value: stats.totalContacts?.toLocaleString() || "0",
      icon: Users,
      color: "blue",
      gradient: "from-blue-500 to-blue-600",
      bgColor: "bg-blue-50",
      textColor: "text-blue-600",
      description: "All contacts across groups",
    },
    {
      title: "Contact Groups",
      value: stats.totalGroups?.toString() || "0",
      icon: Database,
      color: "purple",
      gradient: "from-purple-500 to-purple-600",
    bgColor: "bg-blue-50",
      textColor: "text-blue-600",
      description: "Organized contact groups",
    },
    {
      title: "Recent Uploads",
      value: stats.recentUploads?.toString() || "0",
      icon: Upload,
      color: "red",
      gradient: "from-red-500 to-red-600",
     bgColor: "bg-blue-50",
      textColor: "text-blue-600",
      description: "Uploads in last 30 days",
    },
    {
      title: "Active Groups",
      value: stats.activeGroups?.toString() || "0",
      icon: TrendingUp,
      color: "orange",
      gradient: "from-orange-500 to-orange-600",
 bgColor: "bg-blue-50",
      textColor: "text-blue-600",
      description: "Groups with contacts",
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-6 sm:mb-8">
      {statsData.map((stat, index) => {
        const Icon = stat.icon;
        return (
          <motion.div
            key={stat.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
            className="overflow-hidden relative p-6 bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl border border-blue-200 shadow-md"
          >
            <div className="flex items-center justify-between mb-3 sm:mb-4">
              <div
                className={`w-10 h-10 sm:w-12 sm:h-12 ${stat.bgColor} rounded-lg flex items-center justify-center`}
              >
                <Icon className={`w-5 h-5 sm:w-6 sm:h-6 ${stat.textColor}`} />
              </div>
              <div
                className={`w-2 h-2 rounded-full bg-gradient-to-r ${stat.gradient}`}
              />
            </div>

            <div className="space-y-1 sm:space-y-2">
              <h3 className="text-xs sm:text-sm font-medium text-gray-600 uppercase tracking-wide">
                {stat.title}
              </h3>
              <p className="text-2xl sm:text-3xl font-bold text-gray-900">
                {stat.value}
              </p>
              <p className="text-xs sm:text-sm text-gray-500">
                {stat.description}
              </p>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
};

export default ContactStatsCards;
